import { User } from '@/portainer/users/types';
import { EdgeGroup } from '@/react/edge/edge-groups/types';

// extracted from iota values
export enum EdgeConfigurationType {
  EdgeConfigTypeGeneral = 1,
  EdgeConfigTypeSpecificFile,
  EdgeConfigTypeSpecificFolder,
}

export enum EdgeConfigurationCategory {
  Configuration = 'configuration',
  Secret = 'secret',
}

type EdgeConfigurationProgress = {
  success: number;
  total: number;
};

export enum EdgeConfigStateType {
  EdgeConfigIdleState = 0,
  EdgeConfigFailureState,
  EdgeConfigSavingState,
  EdgeConfigDeletingState,
  EdgeConfigUpdatingState,
}

export const EdgeConfigStateStrings: { [k in EdgeConfigStateType]: string } = {
  [EdgeConfigStateType.EdgeConfigIdleState]: 'Idle',
  [EdgeConfigStateType.EdgeConfigFailureState]: 'Failure',
  [EdgeConfigStateType.EdgeConfigSavingState]: 'Saving',
  [EdgeConfigStateType.EdgeConfigDeletingState]: 'Deleting',
  [EdgeConfigStateType.EdgeConfigUpdatingState]: 'Updating',
};

export type EdgeConfiguration = {
  id: number;
  name: string;
  type: EdgeConfigurationType;
  category: EdgeConfigurationCategory;
  state: EdgeConfigStateType;
  edgeGroupIDs: EdgeGroup['Id'][];
  baseDir: string;
  created: number;
  createdBy: User['Id'];
  updated?: number;
  updatedBy?: User['Id'];
  progress: EdgeConfigurationProgress;
};
